import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {TenantService} from './tenant.service';
import {PricingPlan} from '../models/pricing-plan.model';
import {Observable} from 'rxjs';
import {StripeSession} from './stripe-session';


@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  constructor(
    private http: HttpClient,
    private tenant: TenantService) {

  }

  createPurchaseCourseSession(courseId:string, courseUrl:string, couponCode:string): Observable<StripeSession> {
    return this.http.post<StripeSession>(
      environment.api.purchaseCourseUrl,
      {
        courseId,
        courseUrl,
        tenantId: this.tenant.id,
        couponCode
      });
  }

  createPurchaseBundleSession(bundleCode:string): Observable<StripeSession> {
    return this.http.post<StripeSession>(
      environment.api.purchaseBundleUrl,
      {
        bundleCode,
        tenantId: this.tenant.id,
        baseUrl: `${window.location.protocol}//${window.location.host}`
      });

  }

  createActivatePlanSession(plan: PricingPlan, quantity:number, oneTimeCharge: boolean, subscriptionUrl:string,
                            isTeamPlan:boolean, couponCode?:string): Observable<StripeSession> {
    return this.http.post<StripeSession>(
      environment.api.stripeActivatePlanUrl,
      {
        plan,
        quantity,
        subscriptionUrl,
        tenantId: this.tenant.id,
        oneTimeCharge,
        isTeamPlan,
        couponCode
      });
  }

  createUpdateCardSession(userSettingsUrl:string, stripeCustomerId): Observable<StripeSession> {
    return this.http.post<StripeSession>(
      environment.api.stripeUpdateCardUrl,
      {
        userSettingsUrl,
        stripeCustomerId,
        tenantId: this.tenant.id
      });
  }

  cancelPlan(email:string, displayName: string, reason: string, targetUserId:string = null): Observable<any> {
    return this.http.post(
      environment.api.stripeCancelPlanUrl,
      {
        email,
        displayName,
        tenantId: this.tenant.id,
        reason,
        targetUserId
      }
    );
  }

  cancelCommunityRoomPlan(planToCancel: string, email:string, displayName: string, reason: string, targetUserId:string = null): Observable<any> {
    return this.http.post(
      environment.api.stripeCancelCommunityRoomPlanUrl,
      {
        planToCancel,
        email,
        displayName,
        tenantId: this.tenant.id,
        reason,
        targetUserId,
        testUser: environment.stripe.stripeHostClientId
      }
    );
  }


}
